<template>
  <div class="column landing_buy_redeem p0 h100">
    <div v-if="operation == 'NEW'" class="h100">
      <base-buy-blu @maintenanceCheck="maintenanceCheck"></base-buy-blu>
    </div>
  </div>
</template>

<script>
import BaseBuyBlu from "./base_buy_blu/BaseBuyBlu";

export default {
  created() {},
  mounted() {},
  data: () => ({
    operation: "NEW"
  }),
  components: {
    BaseBuyBlu
  },
  methods: {
    switchTab(tab) {
      this.operation = tab;
    },

    maintenanceCheck(maintananceStatus) {
      this.$emit("maintenanceCheck", maintananceStatus);
    }
  },
  computed: {},
  watch: {}
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/private/landing/LandingBuyRedeem.vue